import { render, staticRenderFns } from "./CustomCheckbox.vue?vue&type=template&id=6eeec968&scoped=true"
import script from "./CustomCheckbox.vue?vue&type=script&lang=ts"
export * from "./CustomCheckbox.vue?vue&type=script&lang=ts"
import style0 from "./CustomCheckbox.vue?vue&type=style&index=0&id=6eeec968&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eeec968",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VHover,VIcon})
